export default [
  {
    path: '/admin/apply/finance/balance',
    name: 'finance-balance',
    meta: { title: '余额管理', headType: 0, auth: true },
    component: () => import('@/views/apply/finance/balance.vue')
  },
  {
    path: '/admin/apply/finance/income',
    name: 'finance-income',
    meta: { title: '收入明细', headType: 0, auth: true },
    component: () => import('@/views/apply/finance/income.vue')
  },
  {
    path: '/admin/apply/finance/withdraw',
    name: 'finance-withdraw',
    meta: { title: '提现管理', headType: 0, auth: true },
    component: () => import('@/views/apply/finance/withdraw.vue')
  },
  {
    path: '/admin/apply/finance/setting',
    name: 'finance-setting',
    meta: { title: '财务设置', headType: 0, auth: true },
    component: () => import('@/views/apply/finance/setting.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/finance.js